import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import * as htmlToImage from 'html-to-image';
import axios from 'axios';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MapViewRBB from '../../../modules/MapViewRBB';
import {
  api,
  authenticate,
  uploadToWeatherTerminalGateway
} from '../../../util/api';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '400px',
  // height: '640px',
  overflow: 'hidden',
  bgcolor: 'background.paper',
  border: '0px solid #fff',
  boxShadow: 2,
  backgroundColor: 'white',
  pt: 2,
  px: 4,
  pb: 3
};

const ChildModal = props => {
  const maps = props.data.maps;

  const [progress1, setProgress1] = React.useState(0);
  const [progress2, setProgress2] = React.useState(0);
  const [progress3, setProgress3] = React.useState(0);

  React.useEffect(() => {
    setProgress1(0);
    setProgress2(0);
    setProgress3(0);
  }, []);
  const onUploaded = (map, status) => {
    if (map === 'hbbtv-heute' && status === 200) {
      setProgress1(100);
    }
    if (map === 'hbbtv-heute-klein' && status === 200) {
      setProgress2(100);
    }
    if (map === 'hbbtv-morgen' && status === 200) {
      setProgress3(100);
    }
  };
  const exportAsPicture = maps => {
    Object.keys(maps).forEach((key, i) => {
      const mapTitle = maps[Object.keys(maps)[i]].id;
      const map = document.getElementById(maps[Object.keys(maps)[i]].id);

      htmlToImage.toPng(map).then(dataUrl => {
        const image = new Image();
        image.src = dataUrl;
        image.setAttribute('id', mapTitle);
        // image.style="border-width:10px;border-color:red;"
        image.className = 'screenshot';
        image.id = mapTitle + '-image';
        document.getElementById('screenshot-container').appendChild(image);
      });
    });

    setTimeout(function () {
      Object.keys(maps).forEach(title => {
        uploadImage(maps[title], onUploaded);
        // createScreenshot(maps[title]);
      });
    }, 1000);
  };

  const dataURLtoFile = (dataUrl, fileName) => {
    let arr = dataUrl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, {type: mime});
  };

  const uploadImage = (map, onUploaded) => {
    const image = document.getElementById(map.id + '-image');
    const imageWidth = map.width / window.devicePixelRatio;
    const imageHeight = map.height / window.devicePixelRatio;
    const options = {width: imageWidth, height: imageHeight, quality: 0.77};
    htmlToImage.toJpeg(image, options).then(async dataUrl => {
      let fileName = map.id;
      if (fileName === 'hbbtv-heute') {
        fileName = 'hdtext_heute_gross';
      } else if (fileName === 'hbbtv-morgen') {
        fileName = 'hdtext_morgen_gross';
      } else if (fileName === 'hbbtv-heute-klein') {
        fileName = 'hdtext_heute_klein';
      }
      // const file = dataURLtoFile(dataUrl, `${map.id}_TEST.jpg`);
      // const file = dataURLtoFile(dataUrl, `${fileName}_TEST.jpg`);
      const file = dataURLtoFile(dataUrl, `${fileName}.jpg`);

      const contentType = 'image/jpeg';
      try {
        // to firebase
        const authResponse = await authenticate();
        axios
          .post(api.files.write(file.name), file, {
            headers: {
              Authorization: `Bearer ${authResponse.idToken}`,
              'Content-Type': contentType
            }
          })
          .then(response => {
            onUploaded(map.id, response.status);
          });

        // to WeatherTerminal Gateway
        uploadToWeatherTerminalGateway(file.name, file, 'image')
          .then(() => {
            onUploaded(map.id, 200);
          })
          .catch(e => {
            console.error(e);
            onUploaded(map.id, 400);
          });
      } catch (err) {
        alert(err.message);
      }
    });
  };

  const fakeSetValueInMap = (item, newData) => {
    console.log('HAhahaha blablabla');
  };

  function handleClose() {
    console.log(document.getElementById('screenshot-container').children);
    setProgress1(0);
    setProgress2(0);
    setProgress3(0);

    props.handleClose();
  }

  return (
    <Modal
      hideBackdrop
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='child-modal-title'
      aria-describedby='child-modal-description'>
      <Box sx={{...style}}>
        <div
          style={{
            width: '100%',
            height: '564px',
            overflow: 'hidden',
            position: 'absolute',
            backgroundColor: 'yellow',
            zIndex: '-1'
          }}>
          <div style={{position: 'relative', width: '100%', height: '100%'}}>
            {Object.keys(props.data.maps).map((key, i) => {
              return (
                <div
                  key={i}
                  style={{
                    backgroundColor: 'yellow',
                    position: 'absolute',
                    margin: '-20px'
                  }}>
                  <MapViewRBB
                    id={props.data.maps[Object.keys(props.data.maps)[i]].id}
                    // className={props.data.maps[i].id}
                    key={i}
                    map={props.data.maps[Object.keys(props.data.maps)[i]]}
                    mapRef={null}
                    data={props.data}
                    parentData={props.parentData}
                    broadcaster={props.data.broadcaster}
                    renderView={true}
                    setValueInMap={fakeSetValueInMap}
                    lockItems={false}
                    unlockItems={false}
                  />
                </div>
              );
            })}
            <div></div>
            <div
              style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                backgroundColor: 'white'
              }}>
              <div
                id='screenshot-container'
                style={{
                  position: 'absolute',
                  top: '-10px',
                  margin: '2px',
                  padding: '2px',
                  backgroundColor: 'white',
                  borderWidth: '22px',
                  borderColor: 'white',
                  borderStyle: 'solid'
                }}></div>

              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  padding: '2px',
                  margin: '2px',
                  borderWidth: '22px',
                  borderColor: 'white',
                  borderStyle: 'solid',
                  backgroundColor: 'white'
                }}
              />
            </div>
          </div>
        </div>

        <h2 id='child-modal-title'>Upload RBB HBBTV</h2>
        <p />
        {/*<p id="child-modal-description">*/}
        {/*<LinearProgress variant="determinate" value={progress}/>*/}
        <p>
          {progress1 ? (
            <CheckCircleIcon color='success' fontSize='large' />
          ) : (
            <HelpOutlineIcon fontSize='large' />
          )}
          {'   '}HDTEXT_HEUTE
        </p>
        <p>
          {progress2 ? (
            <CheckCircleIcon color='success' fontSize='large' />
          ) : (
            <HelpOutlineIcon fontSize='large' />
          )}
          {'   '}HDTEXT_HEUTE KLEIN
        </p>
        <p>
          {progress3 ? (
            <CheckCircleIcon color='success' fontSize='large' />
          ) : (
            <HelpOutlineIcon fontSize='large' />
          )}
          {'   '} HDTEXT_MORGEN
        </p>

        {/*</p>*/}

        <Box style={{display: 'flex', justifyContent: 'space-between'}}>
          <Button variant='contained' onClick={handleClose}>
            Abbrechen
          </Button>
          <Button
            disabled={
              progress1 === 100 && progress2 === 100 && progress3 === 100
            }
            size='large'
            style={{textTransform: 'none', margin: '20'}}
            variant='contained'
            // color="error"
            endIcon={<SendIcon />}
            // onClick={() => exportAsPicture(props.map,props.map.onLock,props.map.onUnlock)}
            onClick={() => exportAsPicture(maps)}
            // onClick={() => setProgress(100)}
          >
            UPLOAD
          </Button>

          <Button
            onClick={handleClose}
            variant='contained'
            color='success'
            disabled={
              progress1 !== 100 && progress2 !== 100 && progress3 !== 100
            }>
            Okay
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChildModal;
